import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { AlgorithmUsageDetailComponent, OrganizationUsageEntry } from '../usage-detail/usage-detail.component';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'ts-algorithm-usage-grid',
    templateUrl: './usage-grid.component.html',
    styleUrls: ['./usage-grid.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [CommonModule, AlgorithmUsageDetailComponent, TranslateModule]
})
export class AlgorithmUsageGridComponent {
  @Input() organizations: OrganizationUsageEntry[];
  @Input() language = 'en';
}
